







import {Component, Vue, Prop} from 'vue-property-decorator';
import RandomSign from '@/components/common/RandomSign.vue';
import {heroesIcons} from '@/constants/heroesIcons';

@Component({
  components: {
    RandomSign,
  },
})
export default class HeroIcon extends Vue {
  @Prop() public hero!: string;
  @Prop() public isRandom!: boolean;

  private heroesIcons = heroesIcons;

  public getHeroSrc() {
    return require(`../../assets/icons/heroes/${this.heroesIcons[this.hero]}`);
  }
}
